/**
 * Account step route (CLA-450) — eagerly registers the file route and its
 * `email` search validator; the step component, its sign-up flows, and the
 * Clerk/atom imports are deferred to `account.lazy.tsx` so they load only with
 * this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * CLA-862: the magic-link `token` is NO LONGER accepted in the URL — it would
 * leak the payment-/connection-capable credential into query strings, OAuth
 * redirects, and PostHog. The token now rides the httpOnly `onboarding_session`
 * cookie (for auth) plus `sessionStorage` (for the RPC body); only the non-secret
 * intake `email` is forwarded through the URL, to pre-fill sign-up.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

/**
 * Narrow the Welcome route's forwarded search into an optional `email`. Kept as
 * a plain function (not a Schema) so the route stays dependency-free and the
 * validator is trivially unit-testable. A `token` key is deliberately dropped
 * (never surfaced) — see the module docs (CLA-862).
 *
 * @since 1.0.0
 */
export const validateAccountSearch = (
  search: Record<string, unknown>,
): { readonly email?: string } => {
  const email = search["email"];
  return typeof email === "string" ? { email } : {};
};

export const Route = createFileRoute("/clawinstall/onboarding/account")({
  validateSearch: validateAccountSearch,
});
